import { createApp } from 'vue'
import App from './App.vue'

const ElementQueries = require('css-element-queries/src/ElementQueries')

import { library } from '@fortawesome/fontawesome-svg-core'
import { faDice } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import './styles/_globals.scss'

library.add(faDice)

const app = createApp(App)
app.config.productionTip = false

ElementQueries.init()

app.component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app')

// ElementQueries.listen()
